import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { appointmentDraftSelectors } from '~/api';
import { envConfigSelectors } from '~/components';

import { TimeSlotsSectionWithAccordion } from './TimeSlotsSectionWithAccordion';
import { groupSlotsByStartTime } from '~/components/calendar-with-filters/time-slots/helpers';
import { getGroupsConfig } from '~/components/calendar-with-filters/date-filters';
import { selectDateSelectors } from '../../../../routes/select-date/select-date.selectors';

export const mapStateToProps = (state, { location, slots, appointmentType, shouldDisableSlot }) => {
  const groupedSlots = groupSlotsByStartTime(slots, getGroupsConfig());

  const addSlotAvailability = (slot) => ({
    ...slot,
    disabled: !!shouldDisableSlot(slot),
  });

  groupedSlots.Morning = groupedSlots.Morning.map(addSlotAvailability);
  groupedSlots.Afternoon = groupedSlots.Afternoon.map(addSlotAvailability);
  groupedSlots.Evening = groupedSlots.Evening.map(addSlotAvailability);

  return {
    slots: groupedSlots,

    title: envConfigSelectors.selectTimeSlotSectionTitle(state),
    displayedSectionName: selectDateSelectors.selectTimeSlotsGroupTitleByAppointmentTypeId(
      groupedSlots,
      appointmentType.id,
    )(state),
    selectedDate: appointmentDraftSelectors.selectAppointmentDateSlot(state),
    isAppointmentBeingEdited: appointmentType.id === location.appointmentTypeIdBeingEdited,
  };
};

export const ConnectedTimeSlotsSectionWithAccordion = withRouter(
  connect(mapStateToProps)(TimeSlotsSectionWithAccordion),
);
